export enum PortalRequestStatus {
	None = 'None',
	Requested = 'Requested',
	Approved = 'Approved',
	Refused = 'Refused',
}
